import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import ScrollToTopButton from './components/ScrollToTopButton'
import Home from './pages/Home'
import QuemSomos from './pages/QuemSomos'
import Solucoes from './pages/Solucoes'
import CentralDoUsuario from './pages/CentralDoUsuario'
import ImprimirBoleto from './pages/ImprimirBoleto'
import SenhaMensal from './pages/SenhaMensal'
import BaixarSuporte from './pages/BaixarSuporte'
import AcessoContador from './pages/AcessoContador'
import AgendarVisita from './pages/AgendarVisita'
import Login from './pages/Login'
import AcessoRestrito from './pages/AcessoRestrito'
import SolucaoSupermercado from './pages/SolucaoSupermercado'
import SolucaoAutopecas from './pages/SolucaoAutopecas'
import SolucaoMaterialConstrucao from './pages/SolucaoMaterialConstrucao'
import SolucaoDistribuidora from './pages/SolucaoDistribuidora'
import SolucaoLojaRoupas from './pages/SolucaoLojaRoupas'
import SolucaoAgropecuaria from './pages/SolucaoAgropecuaria'
import SolucaoPapelaria from './pages/SolucaoPapelaria'
import SolucaoRestaurante from './pages/SolucaoRestaurante'
import SolucaoPostoCombustivel from './pages/SolucaoPostoCombustivel'
import SolucaoEngenharia from './pages/SolucaoEngenharia'
import SolucaoDistribuidoraAgua from './pages/SolucaoDistribuidoraAgua'
import SolucaoEcommerce from './pages/SolucaoEcommerce'
import SolucaoOtica from './pages/SolucaoOtica'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <ScrollToTopButton />
      <Routes>
      {/* Rotas com layout (header + footer) */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/quem-somos" element={<QuemSomos />} />
        <Route path="/solucoes" element={<Solucoes />} />
        <Route path="/solucoes/supermercado" element={<SolucaoSupermercado />} />
        <Route path="/solucoes/autopecas" element={<SolucaoAutopecas />} />
        <Route path="/solucoes/material-de-construcao" element={<SolucaoMaterialConstrucao />} />
        <Route path="/solucoes/distribuidoras-atacadistas" element={<SolucaoDistribuidora />} />
        <Route path="/solucoes/loja-de-roupas" element={<SolucaoLojaRoupas />} />
        <Route path="/solucoes/agropecuaria-e-petshop" element={<SolucaoAgropecuaria />} />
        <Route path="/solucoes/papelaria" element={<SolucaoPapelaria />} />
        <Route path="/solucoes/restaurante" element={<SolucaoRestaurante />} />
        <Route path="/solucoes/posto-de-combustivel" element={<SolucaoPostoCombustivel />} />
        <Route path="/solucoes/engenharia" element={<SolucaoEngenharia />} />
        <Route path="/solucoes/distribuidora-de-agua" element={<SolucaoDistribuidoraAgua />} />
        <Route path="/solucoes/e-commerce" element={<SolucaoEcommerce />} />
        <Route path="/solucoes/otica" element={<SolucaoOtica />} />
        <Route path="/solucoes/:segmento" element={<Solucoes />} />

        {/* Central do Usuário */}
        <Route path="/central-do-usuario" element={<CentralDoUsuario />} />
        <Route path="/imprimir-boleto" element={<ImprimirBoleto />} />
        <Route path="/senha-mensal" element={<SenhaMensal />} />
        <Route path="/baixar-suporte" element={<BaixarSuporte />} />
        <Route path="/acesso-contador" element={<AcessoContador />} />

        <Route path="/agendar-visita" element={<AgendarVisita />} />
      </Route>

      {/* Rotas sem layout (tela cheia) */}
      <Route path="/login" element={<Login />} />
      <Route path="/acesso-restrito" element={<AcessoRestrito />} />
    </Routes>
    </>
  )
}
